<template>
  <div></div>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from "vue"
import { useAuthenticationStore } from "@/store/authentication"

const authStore = useAuthenticationStore()

onMounted(() => {
  window.SupportWidget?.mount(undefined, {
    userEmail: authStore.user?.email,
    projectKey: "H1S",
    sourceProject: "HD",
    primaryColor: "#2699d5",
    primaryColorTo: "#273992",
    appName: "HotelOne"
  })
})

onBeforeUnmount(() => {
  window.SupportWidget?.unmount?.()
  document.getElementById("support-widget")?.remove()
})
</script>
